module.exports = __webpack_public_path__ + "static/media/servicio3.e8cdba75.jpg";